export class CustomTab {

  constructor(
    public id?: number,
    public order?: number,
    public name?: string,
    public wawiSettingsId?: number
  ) {
  }
}
